import React from 'react';
import styled from '@emotion/styled';
import { FormRow, FormLabel, FormRowProps } from '../form-input';

const EditableJsSnippet = styled.textarea`
  flex: 1 1 auto;
  position: relative;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

export interface JsFieldProps extends FormRowProps {
  label: string;
  value?: string;
  onChange: (value: string) => void;
}

export function JsField(props: JsFieldProps) {
  const { label, value, onChange, ...formRowProps } = props;

  const handleChange = (event: React.ChangeEvent<{ value: string }>) => {
    onChange(event.target.value);
  };

  return (
    <FormRow {...formRowProps}>
      <FormLabel>{label}</FormLabel>
      <EditableJsSnippet
        className="highlight-javascript"
        rows={10}
        value={value}
        onChange={handleChange}
      />
    </FormRow>
  );
}
